var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirstFaceOnb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 168,
    viewBox: "0 0 167 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 5355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 149",
    d: "M157.001 76.5341H150.622C150.294 76.5341 150.012 76.3054 149.943 75.9854L147.835 66.1147C147.677 65.3764 146.62 65.386 146.476 66.1271L143.102 83.4587C142.965 84.1617 141.982 84.2213 141.761 83.54L139.084 75.2785C138.877 74.6394 137.973 74.6387 137.765 75.2775L135.633 81.821C135.442 82.4074 134.638 82.4714 134.357 81.9227L131.786 76.9111C131.667 76.6797 131.429 76.5341 131.169 76.5341H39.9024C39.6419 76.5341 39.4034 76.6801 39.2849 76.912L35.5638 84.1935C35.2581 84.7917 34.3655 84.6493 34.2612 83.9856L31.0331 63.4605C30.9138 62.7023 29.8337 62.6707 29.6703 63.4206L26.1779 79.451C26.0236 80.1595 25.0228 80.1858 24.8313 79.4865L22.2225 69.9546C22.0445 69.3042 21.1369 69.2647 20.9031 69.8973L18.6175 76.081C18.5168 76.3533 18.2573 76.5341 17.967 76.5341H11.3594",
    stroke: "#93DAB4",
    strokeWidth: 1.38707
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 207",
    filter: "url(#filter0_f_6069_1633)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.4848,
    cy: 84.019,
    rx: 48.5473,
    ry: 48.4272,
    fill: "#00F370",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 emoji \"slightly frowning face\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M83.4892 117.981C66.8085 117.981 48.8125 107.543 48.8125 84.6393C48.8125 61.7353 66.8085 51.2974 83.4892 51.2974C92.7562 51.2974 101.306 54.3393 107.643 59.8863C114.519 65.9702 118.166 74.5591 118.166 84.6393C118.166 94.7194 114.519 103.249 107.643 109.333C101.306 114.88 92.6964 117.981 83.4892 117.981Z",
    fill: "url(#paint0_radial_6069_1633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M112.122 64.8193C115.308 69.9489 116.97 76.0566 116.97 82.8502C116.97 92.9303 113.323 101.46 106.448 107.543C100.11 113.091 91.5011 116.192 82.2938 116.192C71.4962 116.192 60.1725 111.808 53.4883 102.509C59.9214 113.043 72.0224 117.981 83.4896 117.981C92.6968 117.981 101.306 114.88 107.644 109.333C114.519 103.249 118.166 94.7197 118.166 84.6396C118.166 77.0407 116.092 70.2888 112.122 64.8193Z",
    fill: "#037C3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M71.7674 71.5415C69.2623 71.5415 66.9844 73.653 66.9844 77.1601C66.9844 80.6673 69.2623 82.7728 71.7674 82.7728C74.2784 82.7728 76.5503 80.6613 76.5503 77.1601C76.5503 73.6589 74.3023 71.5415 71.7674 71.5415Z",
    fill: "#0D4219"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M71.5638 73.8844C70.7148 73.4788 69.6924 73.8367 69.2799 74.6837C68.963 75.3458 69.1065 76.139 69.6386 76.652C70.4876 77.0576 71.51 76.6997 71.9225 75.8527C72.2394 75.1907 72.0959 74.3974 71.5638 73.8844Z",
    fill: "#26883C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M94.7283 71.5415C92.2232 71.5415 89.9453 73.653 89.9453 77.1601C89.9453 80.6673 92.2232 82.7728 94.7283 82.7728C97.2334 82.7728 99.5113 80.6613 99.5113 77.1601C99.5113 73.6589 97.2334 71.5415 94.7283 71.5415Z",
    fill: "#0D4219"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M94.4896 73.8844C93.6406 73.4788 92.6182 73.8367 92.2057 74.6837C91.8888 75.3458 92.0323 76.139 92.5644 76.652C93.4134 77.0576 94.4358 76.6997 94.8483 75.8527C95.1652 75.1907 95.0217 74.3974 94.4896 73.8844Z",
    fill: "#26883C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M83.8378 93.7595C89.2605 93.7118 94.45 95.9903 98.0791 100.01C98.3541 100.327 98.4199 100.774 98.2465 101.156C98.0731 101.543 97.6905 101.794 97.266 101.8C97.0747 101.8 96.8834 101.746 96.716 101.651C93.8342 99.9984 89.0154 97.9466 83.8497 97.9466H83.766C78.6064 97.9466 73.7815 99.9984 70.9058 101.651C70.7384 101.746 70.547 101.8 70.3557 101.8C69.9312 101.794 69.5546 101.543 69.3812 101.156C69.2018 100.774 69.2676 100.327 69.5486 100.01C73.1777 95.9903 78.3613 93.7118 83.784 93.7595",
    fill: "#0D4219"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6069_1633",
    x: 0.260845,
    y: 0.915142,
    width: 166.447,
    height: 166.208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.3383,
    result: "effect1_foregroundBlur_6069_1633"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6069_1633",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88.344 93.8486) rotate(-131.701) scale(45.8712 45.8838)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.555597,
    stopColor: "#00F370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstFaceOnb);
export default __webpack_public_path__ + "static/media/first-face-onb.8a64cc182f14b88ea5e11d8a5c64f49c.svg";
export { ForwardRef as ReactComponent };